// extracted by mini-css-extract-plugin
export var card = "_n1-0";
export var content = "_n1-2";
export var details = "_n1-3";
export var icon = "_n1-1";
export var iconBlue = "_n1-5";
export var iconBrand = "_n1-4";
export var iconGrayBlue = "_n1-6";
export var iconGreen = "_n1-7";
export var iconIndigo = "_n1-8";
export var iconOrange = "_n1-9";
export var iconPurple = "_n1-a";
export var iconRed = "_n1-b";
export var iconWarning = "_n1-c";